// import React, { useState } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { postData } from '../../services/FetchNodeServices';
// import { toast } from 'react-toastify';
// import './Login.css'; // Reuse same styles

// const ResetPassword = () => {
//   const { id, token } = useParams();
//   const navigate = useNavigate();
//   const [password, setPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!password || !confirmPassword) {
//       toast.error('Please fill in all fields');
//       return;
//     }

//     if (password !== confirmPassword) {
//       toast.error('Passwords do not match');
//       return;
//     }

//     const response = await postData(`api/v1/auth/reset-password/${id}/${token}`, { password: password, });

//     if (response?.success === true) {
//       toast.success('Password reset successfully!');
//       navigate('/login');
//     } else {
//       toast.error(response?.message || 'Failed to reset password');
//     }
//   };

//   return (
//     <div className="main-login">
//       <div className="login-container">
//         <h2 className="login-title">Reset Password</h2>
//         <form onSubmit={handleSubmit} className="login-form">
//           <div className="form-group">
//             <label>New Password</label>
//             <input
//               type="password"
//               className="form-control"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>
//           <div className="form-group">
//             <label>Confirm Password</label>
//             <input
//               type="password"
//               className="form-control"
//               value={confirmPassword}
//               onChange={(e) => setConfirmPassword(e.target.value)}
//               required
//             />
//           </div>
//           <button type="submit" className="login-button cursor-pointer">Reset Password</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;


import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { postData } from '../../services/FetchNodeServices';
import { toast } from 'react-toastify';
import './Login.css';

const EyeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

const ResetPassword = () => {
  const { id, token } = useParams();
  const navigate = useNavigate();

  const [password,        setPassword]        = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showPassword,    setShowPassword]    = useState(false);
  const [showConfirm,     setShowConfirm]     = useState(false);
  const [loading,         setLoading]         = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      toast.error('Please fill in all fields');
      return;
    }
    if (password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
      return;
    }

    setLoading(true);
    try {
      const response = await postData(`api/v1/auth/reset-password/${id}/${token}`, { password });

      if (response?.success === true) {
        toast.success('Password reset successfully!');
        navigate('/login');
      } else {
        toast.error(response?.message || 'Failed to reset password');
      }
    } catch (error) {
      console.error('Reset password error:', error);
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="main-login">
      <div className="login-container">
        <h2 className="login-title">Reset Password</h2>

        <form onSubmit={handleSubmit} className="login-form">

          {/* New Password */}
          <div className="form-group">
            <label>New Password</label>
            <div className="password-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                className="form-control"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Min 6 characters"
                required
              />
              <button
                type="button"
                className="eye-toggle"
                onClick={() => setShowPassword((v) => !v)}
                tabIndex={-1}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>

          {/* Confirm Password */}
          <div className="form-group">
            <label>Confirm Password</label>
            <div className="password-wrapper">
              <input
                type={showConfirm ? 'text' : 'password'}
                className={`form-control ${
                  confirmPassword && confirmPassword !== password ? 'input-error' : ''
                }`}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="Re-enter new password"
                required
              />
              <button
                type="button"
                className="eye-toggle"
                onClick={() => setShowConfirm((v) => !v)}
                tabIndex={-1}
                aria-label={showConfirm ? 'Hide password' : 'Show password'}
              >
                {showConfirm ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
            {confirmPassword && confirmPassword !== password && (
              <p className="field-error">Passwords do not match</p>
            )}
            {confirmPassword && confirmPassword === password && (
              <p className="field-success">✓ Passwords match</p>
            )}
          </div>

          <button
            type="submit"
            className="login-button cursor-pointer"
            disabled={loading}
          >
            {loading ? 'Resetting…' : 'Reset Password'}
          </button>

        </form>
      </div>
    </div>
  );
};

export default ResetPassword;